

App.controller('PaginationController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', '$filter', 'DataService',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, $filter, D) {
  
    let showPage = function(page){
        return Math.abs($scope.current - page) < numberOfShownPages + 1 || page==0 || page==$scope.pages-1
    }
    let numberOfShownPages = 5

    $scope.pagesArray = []
    for(let i=0; i<$scope.pages; i++){
        $scope.pagesArray.push({i:i,show:showPage(i)})
    }

    $scope.$watch('pages', function(){
        $scope.pagesArray = []
        for(let i=0; i<$scope.pages; i++){
            $scope.pagesArray.push({i:i,show:showPage(i)})
        }
    })

    $scope.$watch('current', function(){
        $scope.pagesArray = []
        for(let i=0; i<$scope.pages; i++){
            $scope.pagesArray.push({i:i,show:showPage(i)})
        }
    })

    
    
    $scope.showPageNumber = function(page){
        return (Math.abs($scope.current - page) < numberOfShownPages || page==0 || page==$scope.pages-1) && $scope.current != page 
    }

    $scope.changePagination = function(page){
        $scope.$parent.changePagination(page)
    }
}])